module.exports = __webpack_public_path__ + "img/257.1aadbd20.png";